<template>
  <editor :id="id" default-tab="group" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Group from './editor/Group'
import ContentLists from './editor/ContentLists'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Group",          name: "group",              component: Group},
        {title: "Content lists",  name: "content_lists",      component: ContentLists}
      ]
    }
  }
}
</script>
